export default "__VITE_ASSET__CFRCcVJm__"